import ReactMarkdown from 'react-markdown';
import { ReadyState } from 'react-use-websocket';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faRotateRight } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import { MessageType } from '@hooks';

import { Button, ChaseSpinner, Icon, Render } from '@components/Shared';

import { Code } from './MarkdownComponents';

type Props = {
  readyState: ReadyState;
  message: MessageType;
  onResendMessage: (message: MessageType) => void;
  isLastMessage?: boolean;
};

export const ChatMessage: React.FC<Props> = ({
  message,
  readyState,
  isLastMessage,
  onResendMessage,
}) => {
  return (
    <li
      key={message.id}
      className={clsx('animate-message-in pt-5', {
        'flex justify-end': message.role === 'user',
      })}
    >
      <div
        className={clsx(
          'relative inline-flex w-fit max-w-full items-center gap-4 rounded-lg px-5 text-sm text-neural-06',
          {
            'py-3 bg-neural-01': message.role === 'user',
            'py-5 border border-neural-02': message.role === 'assistant',
          },
        )}
      >
        <div className="markdown prose prose-neutral max-w-full">
          <ReactMarkdown components={{ code: Code }}>
            {message.content}
          </ReactMarkdown>
        </div>

        <Render
          if={
            message.status === 'error' ||
            (readyState === ReadyState.CLOSED &&
              isLastMessage &&
              message.role === 'user')
          }
        >
          <Button
            theme
            className="group relative ml-2 text-error opacity-75"
            onClick={() => onResendMessage(message)}
          >
            <Icon icon={faTriangleExclamation} size="xl" />
            <Icon
              icon={faRotateRight}
              size="xs"
              className="absolute -right-1 -top-1 h-4 w-4 rounded-full bg-neural-02 p-1 text-neural-06 opacity-0 transition-opacity group-hover:opacity-100"
            />
          </Button>
        </Render>

        <Render if={message.status === 'sending'}>
          <ChaseSpinner
            color="black"
            className="absolute right-1 top-1 h-4 w-4 opacity-50"
          />
        </Render>
      </div>
    </li>
  );
};
